// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyC4bKjQ6rW5PABC0s1jv1VYeThcIdVAQBc',
    authDomain: 'comprarporwhatsapp-develop.firebaseapp.com',
    databaseURL: 'https://comprarporwhatsapp-develop.firebaseio.com',
    projectId: 'comprarporwhatsapp-develop',
    storageBucket: 'comprarporwhatsapp-develop.appspot.com',
    messagingSenderId: '57246915625',
    appId: '1:57246915625:web:272e7d060d873fff289038',
    measurementId: 'G-5B09ZNY1TL',
  },
  boxful: {
    susbcriptionUrl: 'https://pedixwppsocios.boxful.io/subscription_signups?base_plan=2945',
    profileUrl: 'https://pedixwppsocios.boxful.io/membership/subscriptions',
  },
  zenrise: {
    planId: 3376,
    trialDays: 15,
  },
  cdnUrl: null,
  debugAnalytics: true,
  siteUrl: 'https://comprarporwhatsapp-develop.firebaseapp.com',
  baseUrl: 'https://suscripciones.pedix.dev',
  emailDomain: 'pedixwpp.com',
  supportEmail: 'soporte@pedixapp.com',
  stripePublishableKey:
    'pk_test_51HD4yCIhPiaULCWq8ibNzMhYOrhwZdTJEXQKV8Vx00SPGwwjLYMFULsV8CvZfMye1ZoZY1fJVRE5wcy0tZHjQFnF00rNqttEA3',
  priceOptions: {
    AR: {
      priceId: 'price_1HJKhfIhPiaULCWq6O7g8SqU',
      price: '1210',
      priceSymbol: '$',
      priceCurrency: 'ARS',
      labelledPrice: 'Mil pesos argentinos por mes',
    },
    MX: {
      priceId: 'price_1HJKhHIhPiaULCWqZxIJhmLV',
      price: '330',
      priceSymbol: '$',
      priceCurrency: 'MXN',
      labelledPrice: 'Trescientos treinta pesos mexicanos por mes',
    },
    DEFAULT: {
      priceId: 'price_1HD5AEIhPiaULCWqkMoKWgQA',
      price: '15',
      priceSymbol: 'U$S',
      priceCurrency: 'USD',
      labelledPrice: 'Quince dólares estadounidenses por mes',
    },
  },
  adsConversionId: 'AW-16667124382/iCUECI79tugZEJ7FwIs-',
  apiUrl: 'https://pedix.dev',
};
